import { useState, useEffect } from 'react';
import { reportChunkFailure } from '../../utils/appVersion';
export const PagePreview = () => null;

const asyncComponent = (getComponent, LoadingComponent) => {
  const AsyncComponent = (props) => {
    // A component is a function, and React reads a bare function as a lazy
    // initialiser here and as a state updater in setComponent — it would call
    // the loaded component instead of storing it, running its hooks inside this
    // render. Both are wrapped so the function is treated as a value.
    const [Component, setComponent] = useState(() => AsyncComponent.Component);
    const Preview = LoadingComponent || PagePreview;

    useEffect(() => {
      if (!Component) {
        getComponent().then(({ default: LoadedComponent }) => {
          AsyncComponent.Component = LoadedComponent;
          setComponent(() => LoadedComponent);
        }).catch(reportChunkFailure); // CREW-1289: a deploy deleted this route's chunk
      }
    }, [Component]);

    return Component ? <Component {...props} /> : <Preview {...props} />;
  };

  return AsyncComponent;
};

export default asyncComponent;
